export const toastVariants = {
    default: {
        color: 'confirmation',
        borderLeftColor: 'confirmation',
    },
    success: {
        color: 'confirmation',
        borderLeftColor: 'confirmation',
    },
    info: {
        color: 'info',
    },
    error: {
        color: 'error',
    },
    warning: {
        color: 'warning',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9hc3QtdmFyaWFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvdG9hc3QtdmFyaWFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUEyQjtJQUNuRCxPQUFPLEVBQUU7UUFDUCxLQUFLLEVBQUUsY0FBYztRQUNyQixlQUFlLEVBQUUsY0FBYztLQUNoQztJQUNELE9BQU8sRUFBRTtRQUNQLEtBQUssRUFBRSxjQUFjO1FBQ3JCLGVBQWUsRUFBRSxjQUFjO0tBQ2hDO0lBQ0QsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLE1BQU07S0FDZDtJQUNELEtBQUssRUFBRTtRQUNMLEtBQUssRUFBRSxPQUFPO0tBQ2Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxLQUFLLEVBQUUsU0FBUztLQUNqQjtDQUNGLENBQUMifQ==